module.exports = __webpack_public_path__ + "img/atkinsl.1a79ae9d.jpg";